import * as Yup from 'yup';
import { Button, FieldGroup, Input, Spacer, Title } from 'internalLibrary';
import { FC } from 'react';
import { SetNewPasswordFormValues } from '../../../../../types/ui';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import styles from './SetNewPasswordForm.module.scss';

const initialValues: SetNewPasswordFormValues = {
  newPassword: '',
  reenterNewPassword: '',
};

interface SetNewPasswordFormProps {
  onSubmit: (values: SetNewPasswordFormValues) => void;
  isLoading: boolean;
}

const SetNewPasswordForm: FC<SetNewPasswordFormProps> = (props) => {
  const { onSubmit, isLoading } = props;
  const { t } = useTranslation();

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        t('incorrectPasswordFormat'),
      )
      .required('Password is required'),
    reenterNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], t('passwordsMustMatch'))
      .required(t('requiredField')),
  });

  const { handleSubmit, handleChange, handleBlur, values, touched, errors } =
    useFormik({
      validationSchema,
      initialValues,
      onSubmit,
    });

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <Title
        text={t('setNewPassword_title')}
        className={styles.title}
        forceColumn
      />

      <Spacer marginBottom="40px" />

      <FieldGroup
        validationText={touched.newPassword ? errors.newPassword : ''}
      >
        <Input
          label={t('newPassword')}
          name="newPassword"
          touched={touched.newPassword}
          onChange={handleChange}
          error={touched.newPassword && Boolean(errors.newPassword)}
          onBlur={handleBlur}
          value={values.newPassword}
          type="password"
        />
      </FieldGroup>
      <Spacer marginBottom="20px" />

      <FieldGroup
        validationText={
          touched.reenterNewPassword ? errors.reenterNewPassword : ''
        }
      >
        <Input
          label={t('reenterNewPassword')}
          name="reenterNewPassword"
          touched={touched.reenterNewPassword}
          onChange={handleChange}
          error={
            touched.reenterNewPassword && Boolean(errors.reenterNewPassword)
          }
          onBlur={handleBlur}
          value={values.reenterNewPassword}
          type="password"
        />
      </FieldGroup>

      <Spacer marginTop="56px" marginBottom="26px">
        <Button
          className={styles.submit}
          disabled={isLoading}
          type="submit"
          fill={true}
        >
          {t('save')}
        </Button>
      </Spacer>
    </form>
  );
};

export default SetNewPasswordForm;
